import React, { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FileUpload({ label, accept = "image/*", multiple = false, value, onChange, testid = "file-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const list = multiple ? (value || []) : (value ? [value] : []);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(`${BACKEND_URL}${data.url}`);
      }
      if (multiple) onChange([...(value || []), ...urls]);
      else onChange(urls[0]);
    } catch (err) { toast.error("అప్‌లోడ్ విఫలమైంది"); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };

  const remove = (u) => { if (multiple) onChange((value || []).filter((x) => x !== u)); else onChange(""); };
  const isImg = (u) => /\.(png|jpe?g|webp|gif)$/i.test(u) || u.includes("image");

  return (
    <div>
      {label && <label className="text-sm font-semibold text-maroon font-telugu">{label}</label>}
      <div className="mt-1 flex flex-wrap gap-2">
        {list.map((u, i) => (
          <div key={i} className="relative w-20 h-20 rounded-lg overflow-hidden gold-border bg-marigold/10">
            {isImg(u) ? <img src={u} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-2xl">📎</div>}
            <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => remove(u)} className="absolute top-0.5 right-0.5 bg-maroon text-white rounded-full p-0.5"><X className="w-3 h-3" /></button>
          </div>
        ))}
        <button type="button" data-testid={testid} onClick={() => ref.current?.click()} disabled={busy}
          className="w-20 h-20 rounded-lg border-2 border-dashed border-goldline/50 flex flex-col items-center justify-center text-saffron hover:bg-marigold/10">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Upload className="w-5 h-5" />}
          <span className="text-[10px] mt-1 font-telugu">అప్‌లోడ్</span>
        </button>
      </div>
      <input ref={ref} type="file" accept={accept} multiple={multiple} onChange={handle} className="hidden" />
    </div>
  );
}
